import React from 'react';
import './buttonsRedesSign.scss'
import { Link } from 'react-router-dom';



const BtnEmail = ({ linkTo , click}) => (click && click ? ( <div onClick={click} className='ButtonsRedesSignM emailColors' >
<div className='center-container'>
    <div className='img-container'>
        <img src="/img/btns/emailacc.svg" />
    </div>
    <div className='text-container'>
        <p className='text-btn'>
            Correo electrónico
    </p>
    </div>
</div>
</div>) : (<Link style={{ textDecoration: 'none' }} to={linkTo}> 
  <div onClick={click} className='ButtonsRedesSignM emailColors' >
            <div className='center-container'>
                <div className='img-container'>
                    <img src="/img/btns/emailacc.svg" />
                </div>
                <div className='text-container'>
                    <p className='text-btn'>
                        Correo electrónico
                </p>
                </div>
            </div>
        </div>
</Link> ));
export default BtnEmail;


 

